import { Icon } from '../icon';

export const CollapseButton = ({ isCollapsed }: { isCollapsed: boolean }) => {
  return isCollapsed ? (
    <Icon customSizes={{ height: 16, width: 16 }} name={'CircleClosedSVG'} />
  ) : (
    <Icon customSizes={{ height: 16, width: 16 }} name={'CircleOpenSVG'} />
  );
};
